import { render, staticRenderFns } from "./DirectoriesView.vue?vue&type=template&id=0087f37c&scoped=true"
import script from "./DirectoriesView.vue?vue&type=script&lang=js"
export * from "./DirectoriesView.vue?vue&type=script&lang=js"
import style0 from "./DirectoriesView.vue?vue&type=style&index=0&id=0087f37c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0087f37c",
  null
  
)

export default component.exports